import React from 'react'
// import logo from '../images/logo.svg';
// import facebok from '../images/logo/facebook.png'
// import insta from '../images/logo/insta.png'
// import linkedin from '../images/logo/linkedin.png'
// import twitter from '../images/logo/twitter.png'

export const Footer = () => {
    return (
        <footer>
            <div
                className='container'
            // className="container wow animate__animated animate__bounceInUp"
            // data-wow-duration="0.5s"
            // data-wow-delay="0.2s"
            >
                <div className="footer-spacing">
                    <div className="footer-content">
                        {/* <a href='/' className="navbar-brand">
                            <img src={logo} alt="" className='logo' />
                            <div className="name">
                                <span>Alikeu</span>
                                <span>Marketing</span>
                            </div>
                        </a> */}

                        <div className="links-icons">
                            {/* <a href="/">
                                Facebook
                                <i className="fa-solid fa-arrow-right"></i>
                            </a> */}
                            <a href="/">
                                Instagram
                                <i className="fa-solid fa-arrow-right"></i>
                            </a>
                            <a href="/">
                                Linkedin
                                <i className="fa-solid fa-arrow-right"></i>
                            </a>
                            {/* <a href="/">
                                Youtube
                                <i className="fa-solid fa-arrow-right"></i>
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>
            <p className="copyright">
                Copyright &copy; {new Date().getFullYear()} | Alikeu Marketing <span className='mobile-none'>|</span> <span className='mobile-block'> All Rights Reserved</span> <span className='mobile-none'>|</span> <span className='mobile-block'>Designed and Developed by</span> <a href="https://www.edvertotech.com/?tsource=alikeu" target='_blank' rel="noreferrer">Edverto Tech</a>
            </p>
        </footer>
    )
}
